import * as React from 'react';
import { FComponent } from '../../../types/common';
import { PacketLoader } from '../FrictionlessPacket/PacketLoader';
import { FrictionlessPacket } from '../FrictionlessPacket/FrictionlessPacket';
import { useElementDimensions } from '../../../hooks/useElementDimensions';
import {
  RESIZE_FRAME,
  IFrameLoadedMessage,
  SEND_PUBKEY,
  postWindowMessage
} from '../../../utils/messaging';

type EmbeddedPacketProps = {
  userEmail: string;
  gcaptchaKey: string;
  pubkey: string;
};

const handleResize = (width: number, height: number) => {
  postWindowMessage(RESIZE_FRAME({ height, width }));
};

const EmbeddedPacket: FComponent<EmbeddedPacketProps> = ({
  userEmail,
  gcaptchaKey,
  pubkey
}) => {
  const { packetId, referralCode } = getParams();
  const [isSuccess, setIsSuccess] = React.useState(false);

  useElementDimensions(document.body, handleResize);

  const handleLoad = () => {
    const handleMessage = (event: MessageEvent<IFrameLoadedMessage>) => {
      if (event.data.type === 'tt-iframe-loaded') {
        handleResize(document.body.clientWidth, document.body.clientHeight);
      }
    };
    // The reduncancy here is to account for the pages loading in a differnt order
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  };

  const handleSuccess = (pubkey: string) => {
    postWindowMessage(RESIZE_FRAME({ height: 100 }));
    if (pubkey) {
      postWindowMessage(SEND_PUBKEY(pubkey));
    }
    setIsSuccess(true);
  };

  return isSuccess ? (
    <div className="embed-success-message">
      <div className="title">Thank you!</div>
      <div className="subtitle">
        Your data packet was successfully submitted to TARTLE.
      </div>
    </div>
  ) : (
    <PacketLoader packetId={packetId}>
      {packet => (
        <FrictionlessPacket
          gcaptchaKey={gcaptchaKey}
          packet={packet}
          referralCode={referralCode}
          userEmail={userEmail}
          onLoad={handleLoad}
          onSuccess={handleSuccess}
          pubkey={pubkey}
        />
      )}
    </PacketLoader>
  );
};

export { EmbeddedPacket };

const getParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    packetId: urlParams.get('packet_id'),
    referralCode: urlParams.get('referral_code')
  };
};
